import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosTextoQuebraEspecial,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    ExportExcelRight
} from '../../../business-components/Excel/Excel'

import {
    formataListExcel
} from '../../../business-components/Excel/ExcelService'

import {
    GridContainer,
    GridItem11,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    CardGridEstudoPadrao,
} from './EstudoComp'

import {
    tituloCliente,
} from '../cliente-form/ClienteService'

import ReceitaAnualChart from '../estudo-chart/ReceitaAnualChart'



const EstudoFormGarantiasReceitaMensalDetalhada = ( { variaveisGlobais, values, estudo, vars, report, indInicial, indFinal,
    popup, popupGrafico } ) => {

    const GarantiasReceitaMensalDetalhada = () => {

        let headList = [
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoReceitaMensal, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valor, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.tipoPeriodicidadeRecebto, report, null, null, null, true),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorMensalAtual, report),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.perc, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.mesAnoInicialIdadeQuebraEspecial, report,
                    null, null, null, true),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.mesAnoFinalIdadeQuebraEspecial, report,
                    null, null, null, true),
            },
        ]

        return (
            <TableExibeDados
                report={report}
            >
                <TableHeadExibeDados
                    report={report}
                    //popup={popup}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {estudo.current.receitaMensalDetalhada?.map((item, ind) => {
                        return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[0].colSpan}
                                    primeiraColuna={true}
                                >
                                    {item.descricao}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[1].colSpan}
                                >
                                    {item.valor}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[2].colSpan}
                                >
                                    {item.descricaoTipoPeriodicidadeRecebto}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[3].colSpan}
                                >
                                    {item.valorMensal}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[4].colSpan}
                                >
                                    {item.percMensal}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[5].colSpan}
                                >
                                    {item.mesAnoInicial}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[6].colSpan}
                                >
                                    {item.mesAnoFinal}
                                </TableCellBodyExibeDados>
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>  
        )
    }

    return (
        report
            ?
                <GridContainer
                    className={(indInicial === 0 ? 'mt--8' : '') + ' ml-8'}
                >
                    <GridItem11>
                        <GarantiasReceitaMensalDetalhada />
                    </GridItem11>
                </GridContainer>
            :
                <>
                    <ExportExcelRight
                        listExcel={formataListExcel(estudo.current.receitaMensalDetalhada,
                            ['descricao', 'valor', 'descricaoTipoPeriodicidadeRecebto', 'valorMensal',
                                'mesAnoInicial', 'mesAnoFinal'])
                        }
                        nomeArquivoExcel={LABEL.receitaMensal + ' ' + tituloCliente(values)}
                    />

                    <CardGridEstudoPadrao
                        label={LABEL.receitaMensal}
                        component={<GarantiasReceitaMensalDetalhada/>}
                        overflowX={true}
                        popup={popup}
                        grafico={
                            popupGrafico 
                                ? 
                                    <ReceitaAnualChart
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        estudo={estudo}
                                        vars={vars}
                                        popup={true}
                                    />
                                :
                                    ''
                        }
                        graficoTitle={popupGrafico ? LABEL.receitaAnualLongoTempo : ''}
                    />
                </>
    )
}

export default EstudoFormGarantiasReceitaMensalDetalhada